import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import requests from 'app/requests/BillingCompany.requests'

import useGetBillingCompany from '../hooks/useGetBillingCompany'
import getFields from './customerSalesArea.fields'

const CustomerSalesArea = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetBillingCompany(id)

    const getAllowedValues = useEnumValues()

    const fields = useMemo(() => {
        return getFields(getAllowedValues)
    }, [getAllowedValues])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name="CustomerSalesAreaTab"
                value={data}
                onSuccess={invalidate}
                fields={fields}
                requestParams={requests.customerSalesArea({
                    id,
                })}
                exists
            />
        </StatusHandler>
    )
}

export default CustomerSalesArea
